import React, { useEffect, useState, useCallback } from 'react';
import ThermalInvoice from './ThermalInvoice';
import Swal from 'sweetalert2';
import { Button, Card, CardActionArea, CardHeader, Container, Divider, TextField, Typography, Box, Grid, Stack, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { message } from 'antd';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import generateThermalReceiptESCPOS from '../utils/generateThermalReceiptESCPOS';

// --- COMPONENTES AUXILIARES MOVIDOS FUERA DE CheckOut ---

const PortraitView = ({
  contextHolder,
  paymentMethod,
  handlePaymentMethod,
  bank,
  setBank,
  banksOptions,
  reference,
  setReference,
  subTotal,
  ITBISValue,
  cashPaid,
  pendingToPay,
  isPortrait,
  employee,
  ITBIS,
  formValues,
  selectedServices,
  total,
  handlePaidChange,
  previousStepHandler,
  handleReservationSubmit
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      width: '100%',
      minHeight: 'calc(100vhd - 74px)',
      bgcolor: 'background.default',
      p: 0,
      alignItems: 'center',
    }}
  >
    {contextHolder}
    {/* Lado Izquierdo: Métodos de pago y controles */}
    <Box
      sx={{
        bgcolor: 'aliceblue',
        width: { xs: '100%', md: '32%' },
        minWidth: { md: 320 },
        maxWidth: { md: 420 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: 3,
        boxShadow: { md: 2 },
        mb: { xs: 2, md: 0 },
        p: { xs: 0, md: 3 },
        py: 3,
        height: { xs: 'calc(100dvh - 84px)', md: 'calc(100dvh - 74px)' },
      }}
    >
      <Box sx={{ width: '100%', mb: 2, mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h5" sx={{ color: 'rgb(247, 89, 171)', mb: 3, textAlign: 'center' }}>
          Método de pago:
        </Typography>
        <Stack spacing={2} sx={{ width: '70%' }}>
          <CardActionArea onClick={() => handlePaymentMethod('efectivo')}>
            <Card sx={paymentMethod === 'efectivo'
              ? { color: 'green', border: 'green solid 2px', fontSize: '0.8rem' }
              : { color: '#531dab', fontSize: '0.8rem' }}>
              <CardHeader sx={{ fontSize: '0.7rem' }} title='Efectivo' />
            </Card>
          </CardActionArea>
          <CardActionArea onClick={() => handlePaymentMethod('transferencia')}>
            <Card sx={paymentMethod === 'transferencia'
              ? { color: 'green', border: 'green solid 2px', fontSize: '0.8rem' }
              : { color: '#531dab', fontSize: '0.8rem' }}>
              <CardHeader sx={{ fontSize: '0.7rem' }} title='Transferencia' />
            </Card>
          </CardActionArea>
        </Stack>
      </Box>

      {paymentMethod === 'transferencia' && (
        <Box sx={{ width: '100%', mb: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ color: 'rgb(247, 89, 171)', mb: 2, textAlign: 'center' }}>
            Detalles de Transferencia:
          </Typography>
          <Stack spacing={2} sx={{ width: '70%' }}>
            <FormControl fullWidth>
              <InputLabel id="bank-select-label">Banco</InputLabel>
              <Select
                labelId="bank-select-label"
                id="bank-select"
                value={bank}
                label="Banco"
                onChange={(e) => setBank(e.target.value)}
                tabIndex={1}
              >
                {banksOptions.map((b) => (
                  <MenuItem key={b.id} value={b.id}>
                    {b.bank}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Referencia"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              fullWidth
              variant="outlined"
              autoComplete="off"
              tabIndex={2}
            />
          </Stack>
        </Box>
      )}

      {/* Resumen */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'stretch', md: 'center' },
          justifyContent: { xs: 'flex-start', md: 'center' },
          width: { xs: '90%', md: '68%' },
          maxHeight: '220px'
        }}
      >
        <Box sx={{
          width: { xs: '100%', md: '60%' },
          mb: { xs: 2, md: 0 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <Card sx={{
            width: '100%',
            p: { xs: 1, md: 3 },
            borderRadius: 3,
            boxShadow: 2,
            mb: 2,
            background: 'linear-gradient(145deg, #ffffff, #f3f3f3)'
          }}>
            {/* Resumen de pago */}
            <Stack spacing={2}>
              <Typography variant="h6" sx={{ color: '#2c3e50', fontWeight: 600, textAlign: 'center' }}>
                Total a pagar: <Box component="span" sx={{ color: '#e74c3c' }}>
                  RD$ {(Number(subTotal) * ITBISValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </Box>
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography variant="body1" sx={{ color: '#7f8c8d' }}>Restante:</Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500, color: '#e74c3c' }}>
                    RD$ {(cashPaid && (Number(cashPaid) < Number(subTotal) * ITBISValue) && paymentMethod === 'efectivo')
                      ? ((Number(subTotal) * ITBISValue) - Number(cashPaid)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      : '0.00'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1" sx={{ color: '#7f8c8d' }}>Pagado:</Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500, color: '#27ae60' }}>
                    RD$ {cashPaid && paymentMethod === 'efectivo'
                      ? Number(cashPaid).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      : cashPaid ? Number(subTotal * ITBISValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                        : '0.00'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1" sx={{ color: '#7f8c8d' }}>Devuelto:</Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500, color: '#3498db' }}>
                    RD$ {(cashPaid && (Number(cashPaid) > Number(subTotal) * ITBISValue) && paymentMethod === 'efectivo')
                      ? Number(Math.floor((Number(cashPaid) - Number(subTotal) * ITBISValue))).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      : '0.00'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1" sx={{ color: '#7f8c8d' }}>Pendiente:</Typography>
                  <Typography variant="body1" sx={{
                    fontWeight: 500,
                    color: (pendingToPay && pendingToPay > 0) ? '#f39c12' : '#27ae60'
                  }}>
                    RD$ {(pendingToPay && pendingToPay > 0)
                      ? pendingToPay.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      : '0.00'}
                  </Typography>
                </Grid>
              </Grid>
            </Stack>
          </Card>
        </Box>
        {/* Factura térmica */}
        {
          !isPortrait && (
            <Box
              className="invoice-main-container"
              sx={{
                width: { xs: '100%', md: '40%' },
                maxHeight: { xs: 300, md: 'calc(100dvh - 74px)' },
                overflowY: 'auto',
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 1,
                p: { xs: 1, md: 2 }
              }}
            >
              <ThermalInvoice
                employee={employee}
                subTotal={subTotal}
                ITBIS={ITBIS}
                ITBISValue={ITBISValue}
                paymentMethod={paymentMethod}
                formValues={formValues}
                selectedServices={selectedServices}
                cashPaid={cashPaid}
                total={total}
                pendingToPay={pendingToPay}
              />
            </Box>
          )
        }
      </Box>
      <Divider sx={{ width: '100%', mb: 2 }} />
      <Box sx={{ width: '100%', mb: 2 }}>
        <TextField
          label="Total pagado"
          value={paymentMethod === 'efectivo' ? Math.ceil(cashPaid) : Number(subTotal * ITBISValue).toFixed(2)}
          onChange={handlePaidChange}
          name='cashPaid'
          InputProps={{ inputComponent: NumericFormatCustom }}
          variant='outlined'
          fullWidth
          margin='normal'
          autoComplete='off'
          tabIndex={3}
        />
      </Box>
      <Stack direction="row" spacing={2} sx={{ width: '90%', mt: 'auto' }}>
        <Button
          variant='contained'
          onClick={previousStepHandler}
          sx={{
            backgroundColor: '#f759ab', color: '#fff',
            '&:hover': { backgroundColor: '#eb2f96' },
            flex: 1, fontSize: '16px', borderRadius: '8px'
          }}>
          <ArrowBackIosNewIcon /> Regresar
        </Button>
        <Button
          variant='contained'
          sx={{
            backgroundColor: '#f759ab', color: '#fff',
            '&:hover': { backgroundColor: '#eb2f96' },
            flex: 1, fontSize: '16px', borderRadius: '8px'
          }}
          disabled={(ITBIS && (Number(cashPaid) < (Number(subTotal) * ITBISValue))) || (!ITBIS && Number(cashPaid) < Number(subTotal))}
          onClick={handleReservationSubmit}
        >
          Procesar pago
        </Button>
      </Stack>
    </Box>
    <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', md: 'block' }, mx: 2 }} />
  </Box>
);

const LandscapeView = ({
  contextHolder,
  paymentMethod,
  handlePaymentMethod,
  bank,
  setBank,
  banksOptions,
  reference,
  setReference,
  subTotal,
  ITBISValue,
  cashPaid,
  pendingToPay,
  employee,
  ITBIS,
  formValues,
  selectedServices,
  total,
  handlePaidChange,
  previousStepHandler,
  handleReservationSubmit
}) => (
  <div className='checkout-main-container'>
    {contextHolder}
    <div className='left-side-container payment-inf' style={{ backgroundColor: 'aliceblue', alignItems: 'center', width: '30%', height: 'calc(100vh - 74px)', display: 'flex', flexDirection: 'column' }}>
      <div className='methodOf-paid-container' style={{ width: '90%', marginTop: 10 }}>
        <h2 style={{ marginBottom: '50px', color: 'rgb(247, 89, 171)', fontSize: '30px' }}>Método de pago:</h2>
        <CardActionArea style={{ marginBottom: 10 }} onClick={() => handlePaymentMethod('efectivo')}>
          <Card sx={paymentMethod === 'efectivo' ? { color: 'green', border: 'green solid 2px' } : { color: '#531dab' }}>
            <CardHeader title='Efectivo'></CardHeader>
          </Card>
        </CardActionArea>
        <CardActionArea style={{ marginBottom: 10 }} onClick={() => handlePaymentMethod('transferencia')}>
          <Card sx={paymentMethod === 'transferencia' ? { color: 'green', border: 'green solid 2px' } : { color: '#531dab' }}>
            <CardHeader title='Transferencia' ></CardHeader>
          </Card>
        </CardActionArea>
      </div>

      {paymentMethod === 'transferencia' && (
        <div style={{ width: '90%', marginTop: 10 }}>
          <h3 style={{ marginBottom: '20px', color: 'rgb(247, 89, 171)', textAlign: 'center' }}>Detalles de Transferencia:</h3>
          <Stack spacing={2}>
            <FormControl fullWidth>
              <InputLabel id="bank-select-label-landscape">Banco</InputLabel>
              <Select
                labelId="bank-select-label-landscape"
                id="bank-select-landscape"
                value={bank}
                label="Banco"
                onChange={(e) => setBank(e.target.value)}
                tabIndex={1}
              >
                {banksOptions.map((b) => (
                  <MenuItem key={b.id} value={b.id}>
                    {b.bank} - {b.accountNumber}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Referencia"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              fullWidth
              variant="outlined"
              autoComplete="off"
              tabIndex={2}
            />
          </Stack>
        </div>
      )}

      <Divider flexItem sx={{ marginTop: 5 }} />
      <div className='cash-paid-container' style={{ width: '80%', height: '30%', display: 'flex', alignItems: 'center' }}>
        <TextField label="Total pagado"
          value={paymentMethod === 'efectivo' ? Math.ceil(cashPaid) : Number(subTotal * ITBISValue).toFixed(2)}
          onChange={handlePaidChange}
          name='cashPaid'
          InputProps={{
            inputComponent: NumericFormatCustom
          }}
          variant='outlined'
          fullWidth
          margin='normal'
          autoComplete='off'
          tabIndex={3}
        />
      </div>
      <Divider flexItem />
      <div className='control-btn-container' style={{ width: '95%', height: '20%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Button variant='contained' onClick={() => previousStepHandler()}
          sx={{
            backgroundColor: '#f759ab', color: '#fff',
            '&:hover': {
              backgroundColor: '#eb2f96'
            },
            padding: '10px 20px', fontSize: '16px', borderRadius: '8px'
          }}>
          <ArrowBackIosNewIcon /> Regresar
        </Button>
        <Button variant='contained'
          sx={{
            backgroundColor: '#f759ab', color: '#fff',
            '&:hover': {
              backgroundColor: '#eb2f96'
            },
            padding: '10px 20px', fontSize: '16px', borderRadius: '8px'
          }}
          disabled={(ITBIS && (Number(cashPaid) < (Number(subTotal) * ITBISValue))) || (!ITBIS && Number(cashPaid) < Number(subTotal))}
          onClick={() => handleReservationSubmit()}>
          Procesar pago
        </Button>
      </div>
    </div>
    <Divider flexItem orientation='vertical' />
    <div className="right-side-container paid-inf" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', height: '100%', width: '70%' }}>
      <div style={{ width: '65%', display: 'flex', justifyContent: 'center' }}>
        <Card sx={{ width: '70%', padding: 3, borderRadius: 3, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', background: 'linear-gradient(145deg, #ffffff, #f3f3f3)' }}>
          <div className="total-to-paid-container"
            style={{
              width: '100%',
              marginBottom: '20px',
              textAlign: 'center',
              padding: '10px 0',
              borderBottom: '1px solid #d9d9d9',
            }}
          >
            <Typography variant="h4" sx={{ color: '#2c3e50', fontWeight: 600, }} >
              Total a pagar: RD$ {(Number(subTotal) * ITBISValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }} >
            <Typography variant="h6" sx={{ color: '#7f8c8d' }}> Restante:</Typography>
            <Typography variant="h6" sx={{ fontWeight: 500, color: '#e74c3c' }}>
              RD$
              {(cashPaid && (Number(cashPaid) < Number(subTotal) * ITBISValue) && paymentMethod === 'efectivo')
                ? ((Number(subTotal) * ITBISValue) - Number(cashPaid)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : '0.00'}
            </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <Typography variant="h6" sx={{ color: '#7f8c8d' }}> Pagado:</Typography>
            <Typography variant="h6" sx={{ fontWeight: 500, color: '#27ae60' }}>
              RD$
              {
                cashPaid && paymentMethod === 'efectivo' ? Number(cashPaid).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                  : cashPaid ? Number(subTotal * ITBISValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'
              }
            </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <Typography variant="h6" sx={{ color: '#7f8c8d' }}>
              Devuelto:
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 500, color: '#3498db' }}>
              RD$
              {(cashPaid && (Number(cashPaid) > Number(subTotal) * ITBISValue) && paymentMethod === 'efectivo')
                ? Number(Math.floor((Number(cashPaid) - Number(subTotal) * ITBISValue))).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : '0.00'}
            </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#7f8c8d' }}>
              Pendiente por pagar:
            </Typography>
            {(pendingToPay && pendingToPay > 0) ?
              <Typography variant="h6" sx={{ fontWeight: 500 }} color='warning'>
                RD$ {pendingToPay.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Typography>
              : <Typography variant="h6" sx={{ fontWeight: 500 }} color='success'>
                RD$ 0.00
              </Typography>
            }
          </div>
        </Card>
      </div>
      <div className='invoice-main-container' style={{ height: 'calc(100vh - 74px)', overflowY: 'auto', width: '35%' }}>
        <ThermalInvoice employee={employee}
          subTotal={subTotal} ITBIS={ITBIS} ITBISValue={ITBISValue} paymentMethod={paymentMethod} formValues={formValues} selectedServices={selectedServices} cashPaid={cashPaid} total={total} pendingToPay={pendingToPay}
        />
      </div>
    </div>
  </div>
);


const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <NumericFormat {...other} getInputRef={ref}
      onValueChange={(values) => { onChange({ target: { name: props.name, value: values.value, }, }); }}
      thousandSeparator isNumericString prefix="RD$"
    />
  );
});

function parseNumber(str) {
  if (!str) return 0;
  return Number(str.toString().replace(/,/g, ''));
}

function toMySQLDatetime(dateString) {
  const date = new Date(dateString);
  // Ajustar para la zona horaria local para evitar diferencias UTC
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

function CheckOut({ formValues, selectedServices, previousStepHandler, handleSelectedServicesTotal, employee, handleChangePaymentMethod }) {
  const [paymentMethod, setPaymentMethod] = useState('efectivo');
  const [cashPaid, setCashPaid] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [ITBIS, setITBIS] = useState(false);
  const [ITBISValue, setITBISValue] = useState(1);
  const [pendingToPay, setPendingToPay] = useState(0);
  const [printerConfig, setPrinterConfig] = useState(null);
  const [configLoading, setConfigLoading] = useState(false);
  const [extensionInstalled, setExtensionInstalled] = useState(false);
  const [extensionChecked, setExtensionChecked] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [banksOptions, setBanksOptions] = useState([]);
  const [bank, setBank] = useState('');
  const [reference, setReference] = useState('');

  const theme = useTheme();
  const isPortrait = useMediaQuery(theme.breakpoints.down('sm'));

  const handlePaymentMethod = (method) => {
    setPaymentMethod(method);
    handleChangePaymentMethod(method);
    if (method === 'transferencia') {
      fetchBankAccounts();
    }
  };
  const handlePaidChange = (value) => {
    const paid = Number(value.target.value);
    setCashPaid(paid);
  };
  const calculateSubTotal = () => {
    const sumTotal = (selectedServices) => {
      return selectedServices.reduce((acc, service) => {
        const price = (service.amountPaid && service.amountPaid > 0) ? service.amountPaid : (typeof service.amountPaid === 'string' ? parseFloat(service.amountPaid.replace(/,/g, '')) : 0);
        return acc + (price);
      }, 0);
    };
    const deposit = (formValues.reservation && formValues.reservation.deposit && (typeof formValues.reservation.deposit === 'string' ? parseFloat(formValues.reservation.deposit.replace(/,/g, '')) : Number(formValues.reservation.deposit)))
    const subTotal = sumTotal(selectedServices) + deposit;
    setSubTotal(subTotal);
  };
  const calcPendingToPay = () => {
    const sumTotalToPay = (selectedServices) => {
      return selectedServices.reduce((acc, service) => {
        const price = service.priceWDisc && service.priceWDisc > 0 ? service.priceWDisc : (typeof service.servicePrice === 'string' ? parseFloat(service.servicePrice.replace(/,/g, '')) : service.servicePrice);
        return acc + (price * service.quantity);
      }, 0);
    };
    let comboPrice = (formValues.reservation && formValues.reservation.comboPrice && parseFloat(formValues.reservation.comboPrice.replace(/,/g, ''))) || 0;
    comboPrice = comboPrice * ((100 - (formValues.reservation.discount || 0)) / 100);
    const totalToPaid = sumTotalToPay(selectedServices) + comboPrice;
    const pendingToPay = totalToPaid - subTotal;
    setPendingToPay(pendingToPay);
  };

  const calculateTotalOfServices = (selectedServices) => {
    return selectedServices.reduce((acc, service) => {
      const price = service.priceWDisc && service.priceWDisc > 0 ? service.priceWDisc : (typeof service.servicePrice === 'string' ? parseFloat(service.servicePrice.replace(/,/g, '')) : service.servicePrice);
      return acc + (price * service.quantity);
    }, 0);
  };

  const calcTotal = () => {
    const sumTotalToPay = (selectedServices) => {
      return selectedServices.reduce((acc, service) => {
        const price = service.priceWDisc && service.priceWDisc > 0 ? service.priceWDisc : (typeof service.servicePrice === 'string' ? parseFloat(service.servicePrice.replace(/,/g, '')) : service.servicePrice);
        return acc + (price * service.quantity);
      }, 0);
    };
    const sumTotalPaid = (selectedServices) => {
      return selectedServices.reduce((acc, service) => {
        const price = (service.amountPaid && service.amountPaid > 0) ? service.amountPaid : (typeof service.amountPaid === 'string' ? parseFloat(service.amountPaid.replace(/,/g, '')) : 0);
        return acc + (price);
      }, 0);
    };
    const comboPrice = (formValues.reservation && formValues.reservation.comboPrice && parseFloat(formValues.reservation.comboPrice.replace(/,/g, ''))) || 0;
    const comboTotal = comboPrice * ((100 - (formValues.reservation.discount || 0)) / 100);
    const total = sumTotalToPay(selectedServices) + comboTotal;
    setTotal(total);
  };

  // Función helper para enviar mensajes a la extensión
  const sendToExtension = async (message) => {
    return new Promise((resolve, reject) => {
      const extensionId = localStorage.getItem('thermalPrinterExtensionId') || 'your-extension-id-here';

      if (!window.chrome || !window.chrome.runtime) {
        console.error('Chrome runtime no disponible');
        reject(new Error('Chrome runtime no disponible'));
        return;
      }

      // Intentar primero con el ID dinámico de localStorage
      window.chrome.runtime.sendMessage(extensionId, message, (response) => {
        if (window.chrome.runtime.lastError) {
          console.log('Error con ID dinámico, intentando con proxy global:', window.chrome.runtime.lastError.message);

          // Si falla, intentar con el proxy global
          if (window.chrome.runtime.sendMessage) {
            window.chrome.runtime.sendMessage(message, (response) => {
              if (window.chrome.runtime.lastError) {
                console.error('Error con proxy global:', window.chrome.runtime.lastError.message);
                reject(new Error('No se pudo conectar con la extensión'));
                return;
              }
              resolve(response);
            });
          } else {
            reject(new Error('No se pudo conectar con la extensión'));
          }
        } else {
          resolve(response);
        }
      });
    });
  };

  // Función para verificar la extensión en tiempo real
  const checkExtensionRealTime = async () => {
    try {
      const response = await sendToExtension({ action: 'ping' });
      if (response && response.success) {
        setExtensionInstalled(true);
        return true;
      } else {
        setExtensionInstalled(false);
        return false;
      }
    } catch (error) {
      console.error('Error verificando extensión:', error);
      setExtensionInstalled(false);
      return false;
    }
  };

  const fetchAgentPrinterConfiguration = async () => {
    if (isPortrait) return; // No hacer nada si es móvil
    setConfigLoading(true);
    try {
      // Verificar extensión antes de intentar obtener configuración
      const isInstalled = await checkExtensionRealTime();
      if (!isInstalled) {
        console.log('Extensión no instalada para fetchAgentPrinterConfiguration');
        messageApi.warning('La extensión "Proxy Impresora Térmica Local" no está instalada. Instálala para obtener configuración de impresora.');
        setPrinterConfig({ SelectedPrinterName: null, SuggestedCharsPerLine: 48, IsPrinterSelected: false });
        return;
      }

      console.log('Obteniendo configuración de impresora via extensión');
      const response = await sendToExtension({
        action: 'proxyRequest',
        path: '/printer-config',
        method: 'GET'
      });

      if (response && response.success) {
        const config = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
        setPrinterConfig(config); // Guardar toda la configuración
        if (config.IsPrinterSelected) {
          messageApi.success(`Configuración de impresora '${config.SelectedPrinterName}' (${config.SuggestedCharsPerLine} car.) obtenida.`);
        } else {
          messageApi.info(`Agente no tiene impresora predeterminada. Usando ancho ${config.SuggestedCharsPerLine} car.`);
        }
      } else {
        const errorMsg = response && response.error ? response.error : 'Respuesta inválida de la extensión';
        console.error('Error en respuesta de la extensión:', errorMsg);
        messageApi.error(`Fallo al obtener configuración de impresora: ${errorMsg}`);
        setPrinterConfig({ SelectedPrinterName: null, SuggestedCharsPerLine: 48, IsPrinterSelected: false }); // Fallback
      }
    } catch (error) {
      console.error("Error en fetchAgentPrinterConfiguration via extensión:", error);
      messageApi.error("Error al contactar extensión para configuración de impresora.");
      setPrinterConfig({ SelectedPrinterName: null, SuggestedCharsPerLine: 48, IsPrinterSelected: false }); // Fallback
    } finally {
      setConfigLoading(false);
    }
  };

  const fetchBankAccounts = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`https://dprincess-training.servehttp.com/billing-services/bankAccounts/list`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        setBanksOptions(data);
      } else {
        messageApi.open({
          type: 'error',
          content: 'Error al cargar las cuentas bancarias.',
        });
      }
    } catch (error) {
      console.error('Error:', error);
      messageApi.open({
        type: 'error',
        content: 'Error al cargar las cuentas bancarias.',
      });
    }
  };

  const handleDirectThermalPrint = async (invoice) => {
    if (isPortrait) return messageApi.warning('La impresión térmica no está disponible en dispositivos móviles.');
    if (!invoice) {
      messageApi.error('No hay datos de factura para imprimir.');
      return;
    }

    // Chequear la extensión en tiempo real antes de imprimir
    const isInstalled = await checkExtensionRealTime();
    if (!isInstalled) {
      console.log('Extensión no instalada para handleDirectThermalPrint');
      messageApi.warning('La extensión "Proxy Impresora Térmica Local" no está instalada. Instálala para imprimir.');
      return false;
    }

    messageApi.loading({ content: 'Enviando recibo térmico a la impresora...', key: 'thermalPrint' });

    const charsPerLine = printerConfig?.SuggestedCharsPerLine || 48;
    const escposData = await generateThermalReceiptESCPOS(invoice, charsPerLine);

    try {
      console.log('Enviando proxyRequest para /print via extensión');
      const response = await sendToExtension({
        action: 'proxyRequest',
        path: '/print',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: {
          data: escposData,
          printerName: printerConfig.IsPrinterSelected ? printerConfig.SelectedPrinterName : null,
          printType: 'RAW'
        }
      });

      if (response && response.success) {
        const printerUsed = printerConfig.IsPrinterSelected ? printerConfig.SelectedPrinterName : 'impresora predeterminada';
        messageApi.success({ content: `Recibo térmico enviado a ${printerUsed}: ${response.data}`, key: 'thermalPrint', duration: 3 });
        return true;
      } else {
        const errorMsg = response && response.error ? response.error : 'Respuesta inválida de la extensión';
        console.error('Error en respuesta de la extensión:', errorMsg);
        messageApi.error({ content: `Error de impresión: ${errorMsg}`, key: 'thermalPrint', duration: 5 });
        return false;
      }
    } catch (error) {
      console.error('Error al enviar el recibo térmico via extensión:', error);
      messageApi.error({ content: 'Error de conexión con la impresora. Verifique que esté conectada y el agente en ejecución.', key: 'thermalPrint', duration: 5 });
      return false;
    }
  };

  const postFormValues = async (formValues) => {
    const token = localStorage.getItem('token');
    let totalAmount = Number(subTotal) * ITBISValue;
    formValues.totalAmount = totalAmount;
    const creationDate = toMySQLDatetime(new Date());
    formValues.creationDate = creationDate;
    formValues.paymentMethod = paymentMethod; // Asegúrate de que esta variable esté definida
    if (paymentMethod === 'transferencia') {
      formValues.bank = bank;
      formValues.reference = reference;
    }
    try {
      const confirmReq = await Swal.fire({
        title: 'Confirmar creación de reservación',
        text: '¿Estás seguro/a de que deseas crear y facturar esta reservación?',
        icon: 'question',
        showCancelButton: true,
        cancelButtonColor: '#d32f2f',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Crear reservación',
        confirmButtonColor: '#4caf50'
      });

      if (confirmReq.isConfirmed) {
        Swal.fire({
          title: 'Creando reservación...',
          text: 'Por favor espera un momento.',
          icon: 'info',
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        const response = await fetch(`https://dprincess-training.servehttp.com/${formValues.couple ? 'reservations/create-wedding-reservation' : formValues.birthdaydude ? 'reservations/create-birthday-reservation' : 'reservations/create-xv-reservation'}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(formValues)
        });

        if (response.ok) {
          const data = await response.json();

          // Validar que la respuesta tenga la estructura esperada
          if (!data || !data.invoice) {
            console.error('Invalid response structure:', data);
            Swal.close();
            await Swal.fire({
              title: 'Error en respuesta del servidor',
              text: 'La factura se ha procesado con éxito pero la respuesta del servidor no contiene los datos esperados para la impresión de la factura.',
              icon: 'error',
            });
            return;
          }
          if (isPortrait) {
            // Si es modo retrato, no imprimir automáticamente
            Swal.close();
            await Swal.fire({
              title: 'Reservación creada',
              text: 'La reservación se ha creado y facturado correctamente.',
              icon: 'success',
            }).then(() => {
              window.location.reload();
            });
            return;
          }

          const invoice = data.invoice;
          Swal.close();
          await Swal.fire({
            title: 'Reservación creada',
            text: 'La reservación se ha creado y facturado correctamente.',
            icon: 'success',
            confirmButtonText: 'Aceptar'
          });

          // Solo imprimir si tenemos datos válidos
          if (invoice && (invoice.invoiceDetails || invoice.comboPrice) && !isPortrait) {
            Swal.fire({
              title: 'Creando factura...',
              text: 'Por favor espera un momento.',
              icon: 'info',
              allowOutsideClick: false,
              allowEscapeKey: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });

            const groupServicesBySelectedServiceID = (invoiceDetails) => {
              if (!invoiceDetails || !Array.isArray(invoiceDetails)) {
                return [];
              }

              const grouped = {};

              invoiceDetails.forEach(detail => {
                const key = detail.selectedServiceID;

                if (grouped[key]) {
                  // Si ya existe, sumamos el amount
                  grouped[key].amount = (parseNumber(grouped[key].amount) + parseNumber(detail.amount))?.toString();
                  grouped[key].serviceQty = detail.serviceQty;

                  // Mantener el cashFlowID más reciente o crear un array de IDs
                  if (Array.isArray(grouped[key].cashFlowID)) {
                    grouped[key].cashFlowID.push(detail.cashFlowID);
                  } else {
                    grouped[key].cashFlowID = [grouped[key].cashFlowID, detail.cashFlowID];
                  }
                  grouped[key].description = grouped[key].description
                } else {
                  // Si no existe, crear nueva entrada
                  grouped[key] = {
                    ...detail,
                    amount: detail.amount?.toString()
                  };
                }
              });

              // Convertir el objeto agrupado de vuelta a array
              return Object.values(grouped);
            };

            // Calculate paid and pending amounts
            let paidAmount = 0;
            let reservationPaid = [];

            // Validar invoiceAllDetails antes de usarlo
            if (invoice.invoiceAllDetails && Array.isArray(invoice.invoiceAllDetails) && invoice.invoiceAllDetails.length > 0) {
              // Crear la nueva variable con servicios agrupados
              const invoiceDetails = groupServicesBySelectedServiceID(invoice.invoiceAllDetails);
              invoice.invoiceDetails = invoiceDetails;

              for (const details of invoice.invoiceAllDetails) {
                if (details && details.amount) {
                  paidAmount += parseNumber(details.amount);
                  if (details.serviceID === 24) {
                    details.amount = parseNumber(details.amount);
                    reservationPaid.push(details);
                  }
                }
              }
            }
            else {
              // Fallback cuando no hay invoiceAllDetails
              const comboPrice = invoice.comboPrice ? parseNumber(invoice.comboPrice) : 0;
              paidAmount = comboPrice;
              reservationPaid = comboPrice > 0 ? [{ serviceID: 24, amount: comboPrice }] : [];
            }

            // Validar totalAmount antes de calcular pendingAmount
            const totalAmount = invoice.totalAmount ? parseNumber(invoice.totalAmount) : 0;
            invoice.pendingAmount = totalAmount - paidAmount;
            invoice.paidAmount = paidAmount;
            invoice.reservationPaid = reservationPaid;

            try {
              const isPrinted = await handleDirectThermalPrint(invoice);
              if (isPrinted) {
                Swal.close();
                return await Swal.fire({
                  title: 'Reservación creada',
                  text: 'La factura se ha generado e impreso correctamente.',
                  icon: 'success',
                  confirmButtonText: 'Aceptar'
                }).then(() => {
                  window.location.reload();
                });
              }
              else {
                Swal.close();
                return await Swal.fire({
                  title: 'Reservación creada',
                  text: 'La reservación se ha creado correctamente, pero no se pudo imprimir la factura.',
                  icon: 'warning',
                  confirmButtonText: 'Aceptar'
                }).then(() => {
                  window.location.reload();
                });
              }
            } catch (printError) {
              console.error('Error printing:', printError);
              Swal.close();
              messageApi.warning('Reservación creada exitosamente, pero hubo un error al imprimir.');
              await Swal.fire({
                title: 'Error al imprimir',
                text: 'Ocurrió un error al imprimir la factura.',
                icon: 'error',
                confirmButtonText: 'Aceptar'
              });
            }
          }
        }
        else {
          // Leer el mensaje de error del servidor si está disponible
          let errorMessage = 'Ocurrió un error al crear la reservación, por favor intenta de nuevo.';
          const errorData = await response.json();
          if (errorData && errorData.message) {
            errorMessage = errorData.message;
          }
          console.error('Server response error:', response.status, response.statusText);
          Swal.close();
          await Swal.fire({
            title: 'Error creando reservación',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'Aceptar'
          });
        }
      }
      else {
        return messageApi.info('Operación cancelada por el usuario');
      }
    } catch (error) {
      console.error('Error:', error);
      Swal.close();
      await Swal.fire({
        title: 'Error creando reservación',
        text: `Ocurrió un error al crear la reservación: ${error.message}`,
        icon: 'error',
        confirmButtonText: 'Aceptar'
      });
    }
  };

  const handleReservationSubmit = useCallback(async () => {
    const extraservicesTotal = Number(calculateTotalOfServices(selectedServices));
    handleSelectedServicesTotal(extraservicesTotal);
    await postFormValues(formValues);
  }, [subTotal, handleSelectedServicesTotal, formValues, paymentMethod, bank, reference]); // Agregué las dependencias que faltaban

  useEffect(() => {
    calculateSubTotal();
  }, [selectedServices, formValues.reservation]); // Agregué dependencias para que se calcule si cambian los servicios

  useEffect(() => {
    calcPendingToPay();
    calcTotal();
  }, [subTotal, selectedServices, formValues.reservation]); // Agregué dependencias

  useEffect(() => {
    if (!isPortrait && extensionChecked && extensionInstalled) {
      fetchAgentPrinterConfiguration();
    }
  }, [isPortrait, extensionChecked, extensionInstalled]); // Se ejecuta cuando cambia el valor de isPortrait o el estado de la extensión

  // Verificar extensión al montar el componente
  useEffect(() => {
    const checkExtension = async () => {
      try {
        const isInstalled = await checkExtensionRealTime();
        setExtensionChecked(true);
        if (!isInstalled) {
          messageApi.warning('La extensión "Proxy Impresora Térmica Local" no está instalada. Instálala para imprimir recibos térmicos.');
        }
      } catch (error) {
        console.error('Error verificando extensión:', error);
        setExtensionChecked(true);
        messageApi.warning('No se pudo verificar la extensión de impresión térmica.');
      }
    };

    if (!isPortrait) {
      checkExtension();
    } else {
      setExtensionChecked(true);
    }
  }, [isPortrait]);

  // Objeto de props para pasar a los componentes de vista
  const viewProps = {
    contextHolder,
    paymentMethod,
    handlePaymentMethod,
    bank,
    setBank,
    banksOptions,
    reference,
    setReference,
    subTotal,
    ITBISValue,
    cashPaid,
    pendingToPay,
    isPortrait,
    employee,
    ITBIS,
    formValues,
    selectedServices,
    total,
    handlePaidChange,
    previousStepHandler,
    handleReservationSubmit
  };

  return (
    <Box>
      {contextHolder}
      {isPortrait ? <PortraitView {...viewProps} /> : <LandscapeView {...viewProps} />}
      {configLoading && <div className="loading-spinner">Cargando configuración de impresora...</div>}
    </Box>
  )
}

export default CheckOut;